import React from 'react';
import PropTypes from 'prop-types';
import buildProductUrl from '@cotyorg/ccx-server/hydrate/helpers/products/build-product-url';
import HighlightedTitle from '../HighlightedTitle';

// TODO: this function returns the url for a product need be updated to return the actual url
// also the data in the cms may need changing to acccomodate this
export const getURL = ({
  hasResults,
  category = '',
  presentationLocale = '',
  subcategory = '',
  slug = '',
  isServedFromLegacySite,
  legacyURL,
} = {}) => (
  hasResults ? (
    buildProductUrl({
      presentationLocale,
      categorySlug: category,
      subcategorySlug: subcategory,
      productSlug: slug,
      isServedFromLegacySite,
      legacyURL,
    })
  ) : '#'
);

export const getClickHandler = ({
  hasResults,
  title,
  searchURL,
  locale,
  fetchSearchResults,
} = {}) => (e) => {
  if (!hasResults) {
    e.preventDefault();
    fetchSearchResults({
      value: title,
      searchURL,
      locale,
    });
  }
};

// istanbul ignore next
const SearchResultItem = ({
  term,
  title,
  hasResults,
  fetchSearchResults,
  searchURL,
  locale,
  presentationLocale,
  slug,
  category,
  subcategory,
  isServedFromLegacySite,
  legacyURL,
}) => (
  <li className="search__results-list-item">
    <a
      data-test="search-result-item"
      className="search__results-link"
      href={getURL({
        hasResults,
        presentationLocale,
        category,
        subcategory,
        slug,
        isServedFromLegacySite,
        legacyURL,
      })}
      onClick={getClickHandler({
        hasResults,
        title,
        searchURL,
        locale,
        fetchSearchResults,
      })}
    >
      {
        hasResults ? (
          <HighlightedTitle title={title} term={term} />
        ) : (
          title
        )
      }
    </a>
  </li>
);

SearchResultItem.propTypes = {
  title: PropTypes.string.isRequired,
  term: PropTypes.string.isRequired,
  hasResults: PropTypes.bool.isRequired,
  fetchSearchResults: PropTypes.func.isRequired,
  searchURL: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  presentationLocale: PropTypes.string.isRequired,
  slug: PropTypes.string,
  category: PropTypes.string,
  subcategory: PropTypes.string,
  isServedFromLegacySite: PropTypes.bool,
  legacyURL: PropTypes.string,
};

export default SearchResultItem;
